import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import MUIDataTable from 'mui-datatables'

import { Container, Typography } from 'src/modules/ui'
import { Button } from 'src/modules/ui'
import { useActionRunner } from 'src/modules/notification'
import { useRecipes } from '../../hooks'

const IngredientListView = ({ title = 'Ingredients' }) => {
  const history = useHistory()
  const { fetchIngredients, ingredients, isLoading } = useRecipes()

  const [doFetchIngredients] = useActionRunner(fetchIngredients)

  useEffect(() => {
    doFetchIngredients()
  }, [])

  const data = ingredients.map(ingredient => {
    return {
      id: ingredient.id,
      ingredient: ingredient.name,
      unit: ingredient.unit,
    }
  })

  const columns = [
    {
      name: 'ingredient',
      label: 'Ingredient',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'unit',
      label: 'Unit',
      options: {
        filter: true,
        sort: true,
        sortDirection: 'asc',
      },
    },
  ]

  const options = {
    download: false,
    elevation: 0,
    onRowClick: (row, { dataIndex }) => {
      history.push(`/recipes/ingredient/${data[dataIndex].id}/edit`)
    },
    print: false,
    responsive: 'simple',
    rowsPerPage: 20,
    rowsPerPageOptions: [20, 50, 100],
    selectableRows: false,
    viewColumns: false,
  }

  return (
    <>
      <Container muiTable>
        <Button
          href="/recipes/ingredient/create"
          color="lightGreen"
          style={{ marginTop: 20, marginBottom: 10 }}
        >
          Add Ingredient
        </Button>
        {isLoading ? (
          <Typography>Loading...</Typography>
        ) : (
          <MUIDataTable
            columns={columns}
            data={data}
            options={options}
            title={title}
          />
        )}
      </Container>
    </>
  )
}

export default IngredientListView
